import { FirebaseError } from 'firebase/app'

// 権限エラーのみ無視する
export const ignorePermissionError = (error: unknown) => {
  // permission-deniedは限定公開コンテンツに対して、権限がない場合等で返ってくる
  if (error instanceof FirebaseError && error.code === 'permission-denied')
    return
  throw error
}
